import React from "react";
import { FooterNote, StyledSelect } from "../../Common/Components/FormComponents";
import { Section, SectionTitle } from "../../Common/Styles/containers";

interface IGoalModeProps {
  useStrictMode: boolean;
  modifyUseStrictMode: (ev: React.ChangeEvent<HTMLSelectElement>) => void;
}

enum Mode {
  Standard,
  Strict,
}

const GoalMode = (props: IGoalModeProps) => (
  <Section>
    <SectionTitle>Goal Mode</SectionTitle>
    <StyledSelect
      defaultValue={props.useStrictMode ? `${Mode.Strict}` : `${Mode.Standard}`}
      onChange={props.modifyUseStrictMode}
    >
      <option value={Mode.Standard}>{Mode[Mode.Standard]}</option>
      <option value={Mode.Strict}>{Mode[Mode.Strict]}</option>
    </StyledSelect>
    <FooterNote>
      <p>
        Some units allow learners to bypass the lesson if they pass the assessment. This allows learners to "test out"
        of a unit by demonstrating that they already understand its content. This can be overridden by the mode in which
        a course is taken.
      </p>
      <p>In "standard" mode, learners will be able to complete such a unit by passing the assessment.</p>
      <p>
        In "strict" mode, learners will be unable to complete a unit by skipping to the assessment, even if this has
        been allowed by the course author.
      </p>
    </FooterNote>
  </Section>
);

export default GoalMode;
